// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store.js'
import firebase from 'firebase'
import 'firebase/firestore'

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
  // console.log("onAuthStateChanged ok!")
});

Vue.config.productionTip = false

//directive click-outside
Vue.directive('clickoutside', {
	bind: function (el, binding, vnode) {
	    el.clickOutsideEvent = function (event) {
	      // here I check that click was outside the el and his childrens
	      if (!(el == event.target || el.contains(event.target))) {
	        // and if it did, call method provided in attribute value
	        vnode.context[binding.expression](event);
	      }
	    };
	    document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
	    document.body.removeEventListener('click', el.clickOutsideEvent)
	},
	stopProp(event) { event.stopPropagation() }
});


/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js